import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "o-homeEstimateResultHero" }
const _hoisted_2 = { class: "o-homeEstimateResultHero__wrapper" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "o-homeEstimateResultHero__resultBarWrapper u-col-12 lg:u-col-8" }
const _hoisted_6 = { class: "o-homeEstimateResultHero__estimatesRange" }
const _hoisted_7 = ["textContent"]
const _hoisted_8 = ["textContent"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "o-homeEstimateResultHero__resultBar" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "o-homeEstimateResultHero__resultLine" })
], -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/house.svg",
  class: "o-homeEstimateResultHero__imgLeft"
}, null, -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/trees.svg",
  class: "o-homeEstimateResultHero__imgRight"
}, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_o_home_estimate_responsible_broker = _resolveComponent("o-home-estimate-responsible-broker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "o-homeEstimateResultHero__kicker a-lead",
        textContent: _toDisplayString($props.data.headline)
      }, null, 8 /* PROPS */, _hoisted_3),
      _createElementVNode("h1", {
        class: "o-homeEstimateResultHero__headline a-heading2",
        textContent: _toDisplayString($props.data.fullAddress)
      }, null, 8 /* PROPS */, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "a-heading3 o-homeEstimateResultHero__estimateFromLabel",
            textContent: _toDisplayString($props.data.estimateFromLabel)
          }, null, 8 /* PROPS */, _hoisted_7),
          _createElementVNode("div", {
            class: "a-heading3 o-homeEstimateResultHero__estimateToLabel",
            textContent: _toDisplayString($props.data.estimateToLabel)
          }, null, 8 /* PROPS */, _hoisted_8)
        ]),
        _hoisted_9
      ]),
      _createVNode(_component_o_home_estimate_responsible_broker, {
        class: "o-homeEstimateResultHero__responsibleBroker u-col-12 lg:u-col-6",
        "cta-text": $props.data.ctaText,
        "cta-alt-text": $props.data.ctaAltText,
        "broker-introduction-headline": $props.data.brokerIntroductionHeadline,
        "broker-introduction-text": $props.data.brokerIntroductionText,
        "broker-introduction-text-mobile": 
                    $props.data.brokerIntroductionTextMobile
                ,
        broker: $props.data.responsibleBroker
      }, null, 8 /* PROPS */, ["cta-text", "cta-alt-text", "broker-introduction-headline", "broker-introduction-text", "broker-introduction-text-mobile", "broker"])
    ]),
    _hoisted_10,
    _hoisted_11
  ]))
}